import { render, staticRenderFns } from "./ProgressInterest.vue?vue&type=template&id=20d435da&scoped=true&"
import script from "@/views/Users/Student/Progress/ProgressInterest.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Progress/ProgressInterest.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/Progress/progress-interest.scss?vue&type=style&index=0&id=20d435da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d435da",
  null
  
)

export default component.exports